<div class="d-flex justify-content-between text-nowrap">
    <label class="d-inline-block mr-2">{{label}}</label>
    <input style="max-width: 100px" [value]="subscription.value ? subscription.value : '-'"  (ngModelChange)="change()">
</div>